export const bookingEngineDashboard = {
    BOOKING_ENGINE_DASHBOARD_PENDING  : 'BOOKING_ENGINE_DASHBOARD_PENDING',
    BOOKING_ENGINE_DASHBOARD_FULFILLED: 'BOOKING_ENGINE_DASHBOARD_FULFILLED',
    BOOKING_ENGINE_DASHBOARD_REJECTED : 'BOOKING_ENGINE_DASHBOARD_REJECTED',
};
